// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3abUW","header":"ReportDetails_header__2czBZ","title":"ReportDetails_title__3ZKKo","left":"ReportDetails_left__1BSBD"};